import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { loadRoutes, updateRouteSearchCriteria } from "../../redux/actions/routeActions"
import PropTypes from "prop-types";
import RouteCardView from "./RouteCardView";
import RouteTableView from "./RouteTableView";
import Spinner from "../common/Spinner";
import Pagination from "../common/Pagination";
import "./RouteSearch.css";


function RoutesSearch({
    mode,
    subjectUserId,
    groupId,
    routes,
    loadRoutes,
    actions,
    user,
    history,
    loading,
    ...props
}) {

    const [processing, setProcessing] = useState(true);
    const [sortBy, setSortBy] = useState("latest");
    const [results, setResults] = useState({});
    const [searchCriteria, setSearchCriteria] = useState({
        userId: mode == "myroutes" || mode == "bookmarks" ? user.id : null,
        groupId: mode == "grouproutes" ? groupId : null,
        searchBookmarksForUser: mode == "bookmarks",
        pageNumber: "1",
        numberOfResults: "8",
        sortDirection: "DESC",
        sortBy: "DateAdded",
        category: "",
        keywords: "",
        view: mode == "myroutes" || mode == "bookmarks" || mode == "subjectUser" || mode == "grouproutes" ? "card" : "table"
    });
   

    useEffect(() => {

        var data; 
        switch (mode) {
            case "search":
                data = routes.searchResults; 
                break;
            case "myroutes":
                data = routes.myRoutesResults; 
                break;
            case "bookmarks":
                data = routes.bookmarksResults; 
                break;
            case "subjectUser":
                data = { results: [] };
                break;
            case "grouproutes":
                data = { results: [] };
                break;
        }

        if (subjectUserId) {
            searchCriteria.userId = subjectUserId;
        }

        if (!data.results || data.results.length === 0) {
            reloadRoutes(searchCriteria);
        }
        else {
            setSearchCriteria(data.results.searchCriteria);
            setSortBy(translateSort(data.results.searchCriteria));
            setResults(data.results.routes);
            setProcessing(false);
        }
    }, []);

    function reloadRoutes(searchCriteria) {
        setProcessing(true);
        loadRoutes(searchCriteria, mode)
            .then((results) => {
               
                setResults(results);
                setProcessing(false);
            })
            .catch(error => {
                if (error.message === "401") {
                    history.push("/login");
                    return;
                }
                alert("Loading routes failed: " + error);
            });
    }

    function translateSort(sc) {
        if (sc.sortBy == "DateAdded" && sc.sortDirection == "DESC") return "latest"
        if (sc.sortBy == "TotalDistance" && sc.sortDirection == "DESC") return "furthest"
        if (sc.sortBy == "TotalDistance" && sc.sortDirection == "ASC") return "shortest"
        if (sc.sortBy == "TotalElevation" && sc.sortDirection == "DESC") return "hilly"
        if (sc.sortBy == "TotalElevation" && sc.sortDirection == "ASC") return "flat"
    }

    function handlePageForward(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = results.currentPage + 1
        reloadRoutes(criteria);
    }

    function handlePageBack(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = results.currentPage - 1
        reloadRoutes(criteria);
    }

    function handlePageChange(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = e.target.value
        reloadRoutes(criteria);
    }

    function handleFilter(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.category = e.target.value;
        criteria.pageNumber = 1;
        reloadRoutes(criteria);
    }

    function handleSort(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = 1;
        var sort = e.target.value 
        switch (sort){
            case "latest":
                criteria.sortBy = "DateAdded";
                criteria.sortDirection = "DESC";
                break;
            case "furthest":
                criteria.sortBy = "TotalDistance";
                criteria.sortDirection = "DESC";
                break;
            case "shortest":
                criteria.sortBy = "TotalDistance";
                criteria.sortDirection = "ASC";
                break;
            case "hilly":
                criteria.sortBy = "TotalElevation";
                criteria.sortDirection = "DESC";
                break;
            case "flat":
                criteria.sortBy = "TotalElevation";
                criteria.sortDirection = "ASC";
                break;
            default:
                return; 
        }
        setSortBy(sort);
        reloadRoutes(criteria);
    }

    function handleChange(e) {
        var value = e.target.value

        setSearchCriteria(prevSearchCriteria => ({
            ...prevSearchCriteria,
            keywords: value
        }));
    }

    function handleSearch(e) {
        e.preventDefault();
        var criteria = searchCriteria;
        criteria.pageNumber = 1;
        reloadRoutes(criteria);
    }


    return (
       
            
        <div className="route-search col-12">
            <div className="search-toolbar top-form">
                <form onSubmit={handleSearch} >
                    <div className="keywords">
                        <div className="input-group mb-0">
                            <input type="text" className="form-control form-control-sm" value={searchCriteria.keywords} onChange={handleChange} placeholder="Search..." aria-label="Keyword Search" />
                            <div className="input-group-append">
                                <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={handleSearch}></span></button>
                            </div>
                        </div>
                    </div>
                    <div className="category">
                        <label htmlFor="categoryFilter" className="col-form-label text-right">Category</label>
                        <select className="form-control form-control-sm" id="categoryFilter" value={searchCriteria.category} onChange={handleFilter}>
                            <option value="">All</option>
                            <option value="Road">Road</option>
                            <option value="Gravel">Gravel</option>
                            <option value="OffRoad">Off Road</option>
                        </select>
                    </div>
                    <div className="sort d-none d-lg-block">
                        <label htmlFor="sortBy" className="col-form-label text-right">Sort By</label>
                        <select className="form-control form-control-sm" id="sortBy" value={sortBy} onChange={handleSort}>
                            <option value="latest">Latest Uploads</option>
                            <option value="furthest">Furthest Distance</option>
                            <option value="shortest">Shortest Distance</option>
                            <option value="hilly">Most Climbing</option>
                            <option value="flat">Least Climbing</option>
                        </select>
                    </div>
                </form>
            </div>
            {processing ?
                <Spinner /> :
                (
                    <React.Fragment>
                        {searchCriteria.view == "table" ? <RouteTableView routes={results} user={user} /> : <RouteCardView routes={results} user={user} viewMode={mode} /> }
                        {results.results.length > 0 &&
                            <Pagination
                                totalResults={results.totalResults}
                                currentPage={results.currentPage}
                                pageSize={results.pageSize}
                                onPageBack={handlePageBack}
                                onPageForward={handlePageForward}
                                onChangePage={handlePageChange}
                            />
                        }
                    </React.Fragment>
                )
            }
            </div>
              
          
    );

}

RoutesSearch.propTypes =
    {
        routes: PropTypes.object.isRequired,
        loadRoutes: PropTypes.func.isRequired,
        actions: PropTypes.object,
        user: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired
    }


function mapStateToProps(state) {
    return {
        routes: state.routes,
        user: state.user,
        loading: state.apiCallsInProgress > 0
    };
}

const mapDispatchToProps = {
    loadRoutes
}

export default connect(mapStateToProps, mapDispatchToProps)(RoutesSearch); 



// WEBPACK FOOTER //
// ./src/components/routes/RouteSearch.js